import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';

class HistoRow extends Component {
    render() {
        return (
            <>
              <hr className="mt-2 mx-3"/>  
              <div className="historique__container container mr-3  ">
            <div className="histo__filter d-flex">
              <div className="histo__filter col-3 ">
                  <img src={this.props.icon} className='histo__ann__icon' alt="" />
                  <span className='histoRow__txt'>{this.props.name}</span>
              </div>
              <div className="histo__filter col-3 text-center">
                  <span className='histoRow__txt'>{this.props.date} - {this.props.time}</span>
              </div>
              <div className="histo__filter col-1  d-flex justify-content-center mnt" >
                  <span className='histoRow__txt'>{this.props.mont}</span>
              </div>
              <div className="histo__filter col-1 text-center">
                  <span className='histoRow__txt'>{this.props.devise}</span>
              </div>
              <div className="histo__filter col-2 text-center">
                  <span className='histoRow__txt'>{this.props.mode}</span>
              </div>
              <div className="histo__filter col-2 d-flex justify-content-around">
                  <img className='histo__actions' src="/imgs/dash/txt.svg" alt="" />
                  <img className='histo__actions' id="times" src="/imgs/dash/times.svg" alt="" />
                  <img className='histo__actions' src="/imgs/dash/archive_do.svg" alt="" />
              </div>
            </div>
        </div>
  
            </>
        );
    }
}

export default HistoRow;
